import { baseApi } from './baseApi';

export interface Patient {
  id: string;
  name: string;
  email?: string;
  phone?: string;
  // Add other patient fields as needed
}

export interface LicenseUsageRequest {
  license_id: string;
  patient_id?: string;
  access_code?: string;
  device_user_id?: string;
  organization_id?: string;
}

export interface DeviceUserRequest {
  name: string;
  email: string;
  phone: string;
  id_number?: string;
  patient_id?: string;
  age?: number;
  sex?: string;
  diabetic?: boolean;
  bp?: boolean;
  other_health_issues?: string;
  height?: number;
  weight?: number;
  smoking_status?: string;
}

export interface DeviceUserResponse {
  success: boolean;
  message: string;
  data: {
    id: number;
    name: string;
    email: string;
    phone: string;
    organization_id: string;
    updatedAt: string;
    createdAt: string;
  };
}

export interface UpdateSessionRequest {
  id: string
  patient_id?: string;
  organization_id?: string;
  device_user_id?: string;
  session_status: number;
}

export interface DecodeVitalRequest {
  patientId: string;
  encodedData: string;
}

export interface PatientData {
  id?: string;
  firstName: string;
  lastName: string;
  email: string;
  contact: string;
  address: string;
  street: string;
  city: string;
  state: string;
  country_code: string;
  gender_type: string;
  dob: string;
  medical_history?: string;
  allergies?: string;
  blood_group?: string;
  emergency_contact?: string;
  emergency_contact_name?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface PatientDataResponse {
  success: boolean;
  data: {
    patient: PatientData;
    user: {
      id: string;
      email: string;
      firstName: string;
      lastName: string;
      role_id: number;
    };
  };
  message?: string;
}




export const patientApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPatientById: builder.query<any, string>({
      query: (id) => ({
        url: `/patient/getPatientById/${id}`,
        method: 'GET',
      }),
      providesTags: ['Patient'],
    }),
    insertLicenseUsage: builder.mutation<any, LicenseUsageRequest>({
      query: (data) => ({
        url: '/licenseusage/insertLicenseUsage',
        method: 'POST',
        body: data,
      }),
    }),
    updateLicenseUsageSession: builder.mutation<any, UpdateSessionRequest>({
      query: (data) => ({
        url: `/licenseusage/updatesession`,
        method: 'PUT',
        body: data,
      }),
    }),
    // Create a new patient
    createPatient: builder.mutation<PatientDataResponse, Partial<PatientData>>({
      query: (patientData) => ({
        url: '/patient/create',
        method: 'POST',
        body: patientData,
      }),
      invalidatesTags: [{ type: 'Patient', id: 'LIST' }],
    }),
    decodeVitalByPatientId: builder.mutation<any, DecodeVitalRequest>({
      query: ({ patientId, encodedData }) => ({
        url: `/vital/decodeVitalByPatientId/${patientId}`,
        method: 'POST',
        body: { encodedData, client: "web" },
      }),
    }),
    createDeviceUser: builder.mutation<DeviceUserResponse, DeviceUserRequest>({
      query: (data) => ({
        url: '/deviceUser/create',
        method: 'POST',
        body: data,
      }),
    }),
    connectSabai: builder.mutation<any, string>({
      query: (patientId) => ({
        url: `/patient/connectSabai/${patientId}`,
        method: 'PUT',
      }),
    }),
    disconnectSabai: builder.mutation<any, string>({
      query: (patientId) => ({
        url: `/patient/disconnectSabai/${patientId}`,
        method: 'PUT',
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetPatientByIdQuery,
  useInsertLicenseUsageMutation,
  useUpdateLicenseUsageSessionMutation,
  useCreatePatientMutation,
  useDecodeVitalByPatientIdMutation,
  useCreateDeviceUserMutation,
  useConnectSabaiMutation,
  useDisconnectSabaiMutation
} = patientApi;
